module.exports = __webpack_public_path__ + "img/36070-1.prt.890b5f39.jpg";